import axios from 'axios';

const bid = body => axios.get('bid', body);
const acceptBid = ({ bidId }) => axios.post(`bid/${bidId}/accept`, {});
const getBidHistory = ({ listingId }) => axios.get(`bid/loadListing/${listingId}`);
const getListing = ({ listingId }) => axios.get(`loadListing/${listingId}`);

export default {
  bid,
  acceptBid,
  getBidHistory,
  getListing,
};



// WEBPACK FOOTER //
// ./src/api/contract.js